import React from "react";
import { KeyRound, Languages, Lock, Server, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import Section from "../components/Section";
import SectionHeading from "../components/SectionHeading";

/**
 * Security band. Short and factual — this buyer is handing over children's
 * data, and this is the section that closes the deal.
 *
 * Only capabilities the product actually has. No certification badges, because
 * there are no certifications to show.
 */
const ITEMS = [
  { key: "rbac", Icon: KeyRound },
  { key: "audit", Icon: ShieldCheck },
  { key: "sso", Icon: Lock },
  { key: "multilang", Icon: Languages },
  { key: "multitenant", Icon: Server },
];

export default function Security() {
  const { t } = useTranslation();

  return (
    <Section tone="alt">
      <SectionHeading
        eyebrow={t("landing.security.eyebrow")}
        title={t("landing.security.h2")}
        sub={t("landing.security.body")}
      />
      <ul className="mt-10 flex flex-wrap gap-3">
        {ITEMS.map(({ key, Icon }, i) => (
          <li
            key={key}
            className="landing-reveal flex items-center gap-2.5 rounded-lg border border-line bg-white px-4 py-3"
            data-reveal-index={i}
          >
            <Icon className="h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
            <span className="text-sm font-medium text-black-landing">
              {t(`landing.security.${key}`)}
            </span>
          </li>
        ))}
      </ul>
    </Section>
  );
}
